import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=f702672c&scoped=true&"
import script from "./FormTable.vue?vue&type=script&lang=js&"
export * from "./FormTable.vue?vue&type=script&lang=js&"
import style0 from "./FormTable.vue?vue&type=style&index=0&id=f702672c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702672c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f702672c')) {
      api.createRecord('f702672c', component.options)
    } else {
      api.reload('f702672c', component.options)
    }
    module.hot.accept("./FormTable.vue?vue&type=template&id=f702672c&scoped=true&", function () {
      api.rerender('f702672c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormTable.vue"
export default component.exports